export default {
  SEO: {
    description:
      'A special marking is developed to protect you from counterfeit products: a Tested.Genuine. authentication symbol sticker with a unique code. It has been used on the packaging of some categories of Volkswagen, Audi, ŠKODA and Volkswagen Commercial Vehicles genuine spare parts and service fluids since September 2018.',
    lang: 'en',
    meta: ['meta'],
    keywords: ['Volkswagen'],
    title: 'Unique code check',
  },
  Header: {
    Profile: {
      title: 'Sign in',
    },
    DropDown: {
      signIn: 'Sign in',
      registration: 'Registration',
      profile: 'Profile',
      idp: 'My account',
      statistics: 'Statistics',
      logOut: 'Logout',
      main: 'Main page',
    },
    Description: {
      h1: 'Authenticity Check',
      description:
        'Genuine Volkswagen, Audi, &Scaron;KODA and Volkswagen Commercial Vehicles spare parts, engine oil and service fluids are distinguished by&nbsp;their high quality; they perfectly suit the car&rsquo;s characteristics, ensure its safety and maximum efficiency. Check if&nbsp;the product you have purchased is&nbsp;authentic to&nbsp;decide if&nbsp;you want to&nbsp;use&nbsp;it.',
    },
  },
  Sticker: {
    title: 'Sticker Tested. Genuine.',
    description:
      'Sticker Tested.Genuine. products that are often subject to counterfeiting are marked.',
    sticker1: 'Protective layer',
    sticker2: 'Under the protective layer',
  },
  Marking: {
    title: 'What products are labeled?',
    description1: 'Brake pads and discs',
    description2: 'Oil, fuel, air, interior filters',
    description3: 'Engine and transmission oils',
    description4: 'Oils for hydraulic systems and other tech. liquids',
    description5: 'Spark plugs and glow plugs',
    description6: 'Brake fluid',
  },
  Instructions: {
    title: 'What to pay attention to?',
    description:
      'When buying goods, pay attention to the condition and integrity of the sticker - it should not be torn, the protective layer should not be removed.',
    sticker1: 'Undamaged',
    sticker2: 'Slightly teared up',
    sticker3: 'Totally unsticked',
  },
  Form: {
    FeedBack: {
      largeFileError: 'Photo size is too large',
      serverError: 'An error occurred on the server side',
      authError: 'Session has expired, please log in again',
      fill: 'Fill out the feedback form',
      personalH: 'Personal data',
      name: 'How can we&nbsp;address you*',
      requiredField: 'Field is required',
      email: 'e-mail*',
      emailError: 'Enter a&nbsp;valid email address',
      phone: 'Phone*',
      dataH: 'Information about your purchase',
      shop: 'Shop',
      webShop: 'Online store',
      service: 'Service store',
      store: 'Name*',
      address: 'Address*',
      photoCheck: 'Upload receipt scan/photo*',
      photoItem: 'Upload product photo*',
      otherPhoto: 'Upload additional photos',
      notification1:
        'Available download formats: <span>jpeg, png.</span><br /> Maximum download size: <span>100 MB</span>',
      notification2:
        'Please provide a&nbsp;photo of&nbsp;the general view of&nbsp;the package, a&nbsp;close-up photo of&nbsp;the labels, and clear photos of&nbsp;the product from all sides.',
      extraInfoH: 'Extra options*',
      extraInfo: 'Leave a comment or ask a question',
      required: 'Required field*',
      submit: 'Send',
      tokenExpired: 'Action expired. Please continue with login now',
      consent: 'I agree to',
      consentTerms: 'the Terms of Use and Request Processing',
      termsTitle: 'Terms of use and request processing',
      disclaimer: `
      <p><strong>I hereby give my consent to</strong> VOLKSWAGEN Group Rus OOO’s (1 Avtomobilnaya St., Kaluga 248926, / (mailing) address of the Moscow Branch: 30/1 Obrucheva St., Moscow 117485) <strong>processing of the personal data provided by me when filling out the questionnaire on the website</strong> (including name, surname, phone number, email address), as well as data about my location at the time of sending the request (latitude and longitude)</p>
      <p><strong>with the purposes</strong> of processing my request and communicating with me with the purposes related to the processing and fulfilment of my request <strong>via various means</strong>, namely:</p>
      <p>the Internet, email, short messaging service (SMS) and multimedia messaging service (MMS) to my phone number, and also via information and communication services (messaging applications) such as Viber, WhatsApp, etc., and phone calls.</p>
      <p>I allow <strong>the following actions to be performed on my personal data</strong>: collection, systematization, accumulation, storage (in soft and hard copy), rectification (update, modification), use, distribution (including transfer) to third parties (<strong>Aventa-Info OOO, 121099, Moscow, 2nd Smolenskiy lane.1/4, office 4 and AIS OOO, 115404, Moscow, st. 6th Radial, 5 building 4, apt. 250</strong>) with which the VOLKSWAGEN Group Rus OOO has concluded contracts under which VOLKSWAGEN Group Rus OOO entrusts the processing of personal data to third parties for the above purposes, including the cross-border transfer of personal data, blocking, deletion, destruction with or without using automation tools.</p>
      <p>I confirm that when giving my consent to the processing of my personal data above I reside in the Russian Federation.</p>
      <p>This consent to the processing of my personal data is valid until my request is fulfilled, and it may be withdrawn by me earlier in accordance with Article 9 of Federal Law No. 152-FZ "On Personal Data" of July 27, 2006 by sending a respective written application to the mail address of VOLKSWAGEN Group Rus OOO (address of the Moscow branch) specified herein. VOLKSWAGEN Group Rus OOO operates in the Russian Federation in accordance with the legislation of the Russian Federation. Services offered by VOLKSWAGEN Group Rus OOO and the third parties contracted by it for the purposes stated herein are available in the Russian Federation. Consumer behavior outside the Russian Federation is not monitored.</p>
`,
      disclaimerOld:
        'I&nbsp;hereby give my&nbsp;consent to&nbsp;VOLKSWAGEN Group Rus OOO&rsquo;s 1&nbsp;Avtomobilnaya St., Kaluga 248926,&nbsp;/ (mailing) address of&nbsp;the Moscow Branch: 30/1 Obrucheva St., Moscow 117485) processing my&nbsp;personal data as&nbsp;indicated above to&nbsp;process my&nbsp;request sent through www.testedgenuine.ru and to&nbsp;communicate with me&nbsp;on&nbsp;its processing and implementation via various means, namely the Internet, email, short messaging service (SMS) and multimedia messaging service (MMS) to&nbsp;my&nbsp;phone number, and also via information and communication services (messaging applications) such as&nbsp;Viber, WhatsApp, etc., and phone calls. I&nbsp;allow the following actions to&nbsp;be&nbsp;performed on&nbsp;my&nbsp;personal data: collection, systematization, accumulation, storage (in&nbsp;soft and hard copy), rectification (update, modification), use, distribution (including transfer) to&nbsp;third parties (Aventa-Info OOO, INN 7702360374, and AIS OOO, INN 7724897437) with which the VOLKSWAGEN Group Rus OOO has concluded contracts under which VOLKSWAGEN Group Rus OOO entrusts the processing of&nbsp;personal data to&nbsp;third parties for the above purposes, including the cross-border transfer of&nbsp;personal data, depersonalization, blocking, destruction with or&nbsp;without using automation tools. I&nbsp;confirm that when giving my&nbsp;consent to&nbsp;the processing of&nbsp;my&nbsp;personal data above&nbsp;I reside in&nbsp;the Russian Federation. This consent to&nbsp;the processing of&nbsp;my&nbsp;personal data is&nbsp;valid until my&nbsp;request sent through www.testedgenuine.ru is&nbsp;fulfilled, and it&nbsp;may be&nbsp;withdrawn by&nbsp;me&nbsp;earlier in&nbsp;accordance with Article 9&nbsp;of&nbsp;Federal Law No. 152-FZ &laquo;On&nbsp;Personal Data&raquo; of&nbsp;July&nbsp;27, 2006 by&nbsp;sending a&nbsp;respective written application to&nbsp;the mail address of&nbsp;VOLKSWAGEN Group Rus OOO (address of&nbsp;the Moscow branch) specified herein. VOLKSWAGEN Group Rus OOO operates in&nbsp;the Russian Federation in&nbsp;accordance with the legislation of&nbsp;the Russian Federation. Services offered by&nbsp;VOLKSWAGEN Group Rus OOO and the third parties contracted by&nbsp;it&nbsp;for the purposes stated herein are available in&nbsp;the Russian Federation. Consumer behavior outside the Russian Federation is&nbsp;not monitored.',
    },
    question: {
      findCode: 'How to find the verification code',
      findCodeForHeader: 'Check code',
      whyAutorization: 'Why use authorization?',
    },
    sendCodeBlock: {
      checkCode: 'Check',
      autorization: 'Login',
      support: 'Leave feedback',
    },
    support: 'Leave feedback',
    enterCode: 'Enter code',
    enterCodeHeader: 'Enter code',
    isLoading: 'Please wait while we&nbsp;process your request.',
    isContrafact:
      'I&nbsp;have bought a&nbsp;counterfeit product. What do&nbsp;I&nbsp;do?',
    isErrorCode: 'No such number',
    title:
      'Enter a&nbsp;unique <br>15-digit code to&nbsp;check <br>your product.',
    description:
      'If&nbsp;the product you have purchased is&nbsp;not genuine, you have the right to&nbsp;return it&nbsp;and demand a&nbsp;refund under Article 18&nbsp;of&nbsp;the Law On&nbsp;Protection of&nbsp;Consumer Rights.',
    tooltipInfo: {
      findCode:
        'A&nbsp;unique 15-digit code is&nbsp;a&nbsp;safe way to confirm originality and quality of&nbsp;the purchased product. You can find the&nbsp;code on&nbsp;the underlayer of&nbsp;the unit package on&nbsp;the tamper sticker.',
      whyAutorization:
        'Upon authorization, you get access to your personal profile where you can see your product check history and send us messages.',
    },
    status: {
      n: 'Genuine code',
      k: 'Code not registered',
      d: 'Reverified Code',
    },
  },
  Media: {
    title: 'How to tell an original product from an imitation?',
    items: [
      {
        title: 'Original or counterfeit',
        description:
          'What stands behind counterfeit products and how to detect them.',
        downloadText: 'Download',
        download: [
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_Parts_Brochure_AUDI_ENG.pdf`,
            cover: 'originalAudi_en',
          },
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_Parts_Brochure_SKODA_ENG.pdf`,
            cover: 'originalSkoda_en',
          },
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_Parts_Brochure_VW_ENG.pdf`,
            cover: 'originalVw_en',
          },
          {
            href: `${process.env.GATSBY_MEDIA_CONTENT}/Original_parts_brochure_NFZ.pdf`,
            cover: 'originalVwCom',
          },
        ],
      },
      {
        title: 'Brake Pads and Discs',
        description:
          'Learn about the results of comparison tests of genuine and counterfeit spare parts.',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/tormoza_en.mp4`,
          name: 'tormoza_en',
          cover: 'brakes',
        },
      },
      {
        title: 'Alloy Wheels',
        description:
          'Will a counterfeit disk survive hitting an obstacle? Learn from this video.',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/diski_en.mp4`,
          name: 'diski_en',
          cover: 'discs',
        },
      },
      {
        title: 'Oil Filters',
        description:
          'How is counterfeit oil different from the genuine one? And how will it affect the engine? Learn more',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/maslo_en.mp4`,
          name: 'maslo_en',
          cover: 'oil',
        },
      },
      {
        title: 'Engine oil',
        description:
          'What is the difference between the original and the fake? What threatens the engine to use counterfeit products?',
        video: {
          href: `${process.env.GATSBY_MEDIA_CONTENT}/engine_oil.mp4`,
          name: 'engine_oil',
          cover: 'engine_oil',
        },
      },
    ],
  },
  Dealers: {
    title: 'Official dealers',
    map: 'Go to map',
    items: [
      {
        name: 'Volkswagen',
        href:
          'https://www.volkswagen.ru/app/dealers/vw-ru/ru/%D0%94%D0%B8%D0%BB%D0%B5%D1%80%D1%8B%20Volkswagen/+/53.72267442183233/47.7992045/4/+/+/+/+',
      },
      {
        name: 'Volkswagen<br>Commercial Vehicles',
        href:
          'https://www.volkswagen-commercial.ru/app/dealers/vwn-ru/ru/%D0%94%D0%B8%D0%BB%D0%B5%D1%80%D1%8B%20Volkswagen%20%D0%9A%D0%BE%D0%BC%D0%BC%D0%B5%D1%80%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B5%20%D0%B0%D0%B2%D1%82%D0%BE%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D0%B8/+/52.619/47.79920449999997/4/+/+/+/+',
        classForCommercialName: 'commercial',
      },
      {
        name: 'Audi',
        href: 'https://www.audi.ru/ru/web/ru/dealer-search.html',
      },
      {
        name: 'ŠKODA',
        href: 'http://www.skoda-avto.ru/dealer',
      },
    ],
  },
  Contacts: {
    hotline: 'Hotline<br /> &laquo;Unique code check&raquo;',
    vwApp: 'Mobile app <br /> &laquo;Volkswagen Service&raquo;',
    audiApp: 'Mobile app <br /> &laquo;Audi Service&raquo;',
    phone: '+78007007328',
    formatPhone: '+7 800 700-73-28',
    qr: 'QR Code',
    vw: {
      qr: 'vw',
      title: 'Mobile app <br /> &laquo;Volkswagen Service&raquo;',
      googleplay:
        'https://play.google.com/store/apps/details?id=ru.vwgroup.service&hl=ru',
      appstore: 'https://itunes.apple.com/us/app/vw-servis/id575858147?mt=8',
    },
    audi: {
      qr: 'audi',
      title: 'Mobile app <br /> &laquo;Audi Service&raquo;',
      googleplay:
        'https://play.google.com/store/apps/details?id=ru.audi.service&hl=ru',
      appstore: 'https://itunes.apple.com/us/app/audi-service/id664580565?mt=8',
    },
    skoda: {
      qr: 'skoda',
      title: 'Mobile app <br /> &laquo;ŠKODA&raquo;',
      googleplay:
        'https://play.google.com/store/apps/details?id=ru.skoda.service',
      appstore: 'https://apps.apple.com/ru/app/skoda-app/id1491066713',
    },
  },
  Footer: {
    description:
      'Shall you encounter a counterfeit, please send us an email with «Counterfeit» as the subject at <a href="mailto:tg@vgrus.ru">tg@vgrus.ru</a> (for all brands).',
    copy: '&copy;&nbsp;2023&nbsp;VOLKSWAGEN Group Rus. All rights reserved.',
  },
  Profile: {
    title: 'Checks',
    buttonCheck: 'Check product',
    warningMessage: `Dear Ladies and&nbsp;Gentlemen, the&nbsp;user's personal account is&nbsp;in&nbsp;test mode. If&nbsp;errors are&nbsp;found, please report to&nbsp;the&nbsp;<a href="mailto:tg@vgrus.ru">tg@vgrus.ru</a>. We&nbsp;apologize for&nbsp;the&nbsp;inconvenience.`,
    filters: {
      numberOfChecks: 'All checks',
      myChecks: 'My feedback',
      reverifiedsCode: 'Reverified Code',
      codeNotRegistered: 'Code not registered',
      genuineCode: 'Genuine code',
    },
    infoCheck: {
      mainInfo: {
        code: 'Code:',
        result: 'Result:',
        date: 'Date:',
        device: 'App:',
        web: 'website',
        mobile: 'mobile app',
        place: 'Check place:',
        checks: 'Feedback:',
        status: {
          n: 'Authenticated',
          k: 'Possible counterfeit! <br> Code not registered ',
          d: 'Possible counterfeit! The code you entered was checked ',
          region: 'Region of the previous check: ',
        },
      },
      details: {
        numberOfChecks: 'Number of my checks:',
        supportButton: 'Leave feedback',
        supportNumber: 'Support number: +7 800 700-73-28',
        downloadResult: 'Download check result',
        sendResult: 'Send result to mail',
        sendMail: 'Result sent to mail',
        myChecks: 'My feedback',
        myCheck: '(My check)',
        check: {
          checkNumber: '№ Appeal:',
          trade: 'Place:',
          place: 'Name:',
          time: 'Time:',
          comment: 'Comment:',
        },
      },
    },
  },
  Statistics: {
    title: 'Statistics',
  },
};
